export default __webpack_public_path__ + "static/media/mobile_90s@3x.4e9b5b83.jpg";